import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

import { allTokensRegex } from 'containers/Tiptap/lib/header-footer-variables';

export const HeaderFooterVariableDecoration = Extension.create({
  name: 'headerFooterVariableDecoration',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('headerFooterVariableDecoration'),
        props: {
          decorations(state) {
            const decorations: Decoration[] = [];
            state.doc.descendants((node, pos) => {
              if (!node.isText || !node.text) return;
              const regex = allTokensRegex();
              let match = regex.exec(node.text);
              while (match !== null) {
                const from = pos + match.index;
                decorations.push(
                  Decoration.inline(from, from + match[0].length, { class: 'tiptap-hf-variable' }),
                );
                match = regex.exec(node.text);
              }
            });
            return DecorationSet.create(state.doc, decorations);
          },
        },
      }),
    ];
  },
});
